import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=443eb308&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports